let sound

export default function (el, { value }) {
  el.soundUrl = value

  el.addEventListener('click', () => {
    if (sound) {
      sound.pause()
    }
    sound = new Audio(el.soundUrl)

    sound.play()
  })
}
